'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _canonical = require('./canonical');

Object.defineProperty(exports, 'canonical', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_canonical).default;
  }
});

var _convenient = require('./convenient');

Object.defineProperty(exports, 'convenient', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_convenient).default;
  }
});

var _helpers = require('./helpers');

Object.defineProperty(exports, 'minute', {
  enumerable: true,
  get: function get() {
    return _helpers.minute;
  }
});
Object.defineProperty(exports, 'hour', {
  enumerable: true,
  get: function get() {
    return _helpers.hour;
  }
});
Object.defineProperty(exports, 'day', {
  enumerable: true,
  get: function get() {
    return _helpers.day;
  }
});
Object.defineProperty(exports, 'month', {
  enumerable: true,
  get: function get() {
    return _helpers.month;
  }
});
Object.defineProperty(exports, 'year', {
  enumerable: true,
  get: function get() {
    return _helpers.year;
  }
});
Object.defineProperty(exports, 'getStep', {
  enumerable: true,
  get: function get() {
    return _helpers.getStep;
  }
});
Object.defineProperty(exports, 'getDate', {
  enumerable: true,
  get: function get() {
    return _helpers.getDate;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/javascript-time-ago/modules/gradation/index.js
// module id = 127
// module chunks = 0